import { Tooltip } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import type { Deal } from "@/types/deal";
import {
  daysInStatus,
  statusAgeColour,
  statusAgeTooltip,
} from "../pipelineMeeting";

/**
 * Meeting view Status cell: the status name followed by the number of days
 * the row has been in it (not shown for closed statuses or without history).
 * Hovering the number shows the date it entered the status.
 */
export function StatusAgeCell(params: ICellRendererParams<Deal>) {
  const label = params.valueFormatted ?? "";
  const days = params.data ? daysInStatus(params.data) : null;
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 6,
        width: "100%",
        minWidth: 0,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
      {days !== null && params.data && (
        // The app's themed tooltip, not the browser's native title.
        <Tooltip title={statusAgeTooltip(params.data)} placement="top">
          <span
            data-testid="status-age"
            style={{
              color: statusAgeColour(days),
              fontWeight: 600,
              fontVariantNumeric: "tabular-nums",
              flexShrink: 0,
            }}
          >
            {days}
          </span>
        </Tooltip>
      )}
    </span>
  );
}
